import { createFileRoute } from "@tanstack/react-router";
import PlatformeGuide from "@/pages/ghiduri/PlatformeGuide";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/ghiduri/platforme-auto-romania-cum-alegi/")({
  head: () => routeHead("/ghiduri/platforme-auto-romania-cum-alegi/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PlatformeGuide />
  );
}
